export const numberWithSpaces = (value: string, pattern: string) => {
  let i = 0;
  const phone = value.toString();

  return pattern.replace(/#/g, (_) => phone[i++]);
};
